
import state from './../../../../../zviz2/zviz/state';
import {Controller as GroupController} from './../../../../../zviz2/zviz/components/group';
import {extend, cloneObject} from './../../../../../zviz2/zviz/functions';



import Country from './country';


class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);
        
        this.scale = 0;
        this.position = {x: 0, y: 0};
        this.boundingBox = [{x: 0, y: 0}, {x: 0, y: 0}];
        
    }

    render(renderer){
        
        this.getTransformation().setObjectScale(this.models['geo'].scale);
        this.getTransformation().setPosition(this.models['geo'].position.x, this.models['geo'].position.y);
        super.render(renderer);
    }

    zoomTo(boundingBox){

        if(boundingBox[0].x == 0 && boundingBox[1].x == 0){
            boundingBox = this.models['geo'].globalBounds;
        }
 
        let xShift = 0;
        if(this.data.width>700){
            xShift = Math.max(0.5*(this.data.width-1138)+460, 460);
        }

        let wScale = (this.data.width-xShift-20) / (boundingBox[1].x - boundingBox[0].x);
        
        let maxScale = this.data.maxScale;
        if(wScale > maxScale){
            let ox = 0.5 * (wScale/maxScale) * (boundingBox[1].x - boundingBox[0].x);
            let oy = 0.5 * (boundingBox[1].y - boundingBox[0].y)
            boundingBox[0].x -= ox;
            boundingBox[0].y -= oy;
            boundingBox[1].x += ox;
            boundingBox[1].y += oy;
            wScale = maxScale;
        }

        
        let maxH = (this.data.autoHeight)? this.data.maxHeight: this.data.height;
        let hScale = maxH / (boundingBox[1].y - boundingBox[0].y);

        let scale = Math.min(wScale, hScale);
        let width = scale * (boundingBox[1].x - boundingBox[0].x);
        let height = scale * (boundingBox[1].y - boundingBox[0].y);

        let aH = (this.data.autoHeight)? 200: this.data.height;
        if(height < aH){
            let o = 0.5 * (aH - height);
            if(state.get('renderSize') == 'small'){
                boundingBox[0].y -= 0.3 * o / scale;
                boundingBox[1].y += 1.7 * o / scale;
            }else{
                boundingBox[0].y -= o / scale;
                boundingBox[1].y += o / scale; 
            }
            height = aH;
        }

        // xShift = Math.max(0.5*(this.data.width-1138)+0.5*460, 0.5*460);

        let position = {
            x: -1*scale*boundingBox[0].x + 0.5*(this.data.width - scale * (boundingBox[1].x - boundingBox[0].x)) + 0.5*xShift,
            y: -1*scale*boundingBox[0].y
        }

        this.trigger('height', height);

        if(this.scale != scale || this.position.x != position.x || this.position.y != position.y){
            this.scale = scale;
            this.position = position;
            this.boundingBox = boundingBox;
            this.getByUid('map').resetZoom();
            state.set('map.zoomScale', 1);
            state.set('map.zoomPan', {x: 0, y: 0});
            this.userZoom();    // explicitly call this, because zoom and panning may not have changed
        }

        // this.models['geo'].setZoom(scale, position, boundingBox);
    
    }

    userZoom(){
        let scale = state.get('map.zoomScale') || 1;
        let pos = state.get('map.zoomPan') || {x: 0, y: 0};

        let xShift = 0;
        if(this.data.width>700){
            xShift = Math.max(0.5*(this.data.width-1138)+460, 460);
        }
        let s = 1/ scale;
        let b = this.boundingBox;
        let w = 0.5 * (b[1].x - b[0].x);
        let h = 0.5 * (b[1].y - b[0].y);
        let c = [b[0].x + w - pos.x/(this.scale*scale), b[0].y + h - pos.y/(this.scale*scale)];
        let boundingBox = [
            {x: c[0] - s * w, y: c[1] - s * h},
            {x: c[0] + s * w, y: c[1] + s * h}
        ];
        let position = {
            x: -1*this.scale*scale*boundingBox[0].x + 0.5*(this.data.width - this.scale*scale * (boundingBox[1].x - boundingBox[0].x)) + 0.5*xShift,
            y: -1*this.scale*scale*boundingBox[0].y
        }

        this.models['geo'].setZoom(scale*this.scale, position, boundingBox);
    }

    getSelection(){
        if(this.data.selected){
            return this.data.selected;
        }
        
        return false;
    }

    getChildren(){

        let geo = this.models['geo'];
        if(geo.status != 'success'){
            return [];
        }


        this.getTransformation().setObjectScale(geo.scale);
        this.getTransformation().setPosition(geo.position.x, geo.position.y);

        let result = [];

        let hover = state.get('map.itemHover');
        let hoverDim = false;
        let hoverVal = false;
        if(hover){
            hoverDim = hover[0];
            hoverVal = hover[1];
        }

        let selection = this.getSelection();
        let highlight = state.get('map.countryHighlight');

        for(let c of geo.countryPaths){

            let opacity = 1;
            let selected = false;
            if(this.data.highlight){
                selected = geo.isInSelection(c.id, selection);
            }
            if(selected && highlight){
                if(geo.isInSelection(c.id, highlight)){
                    opacity = 1;
                }else{
                    opacity = 0.5;
                }
            }

            let node = geo.countryData.get(c.id);

            let data = cloneObject(node); //false;
            // if(this.data.type == 'chorochromatic' || this.data.type == 'travel'){
            //     data = this.models['map'].getDataForNode(node);
            // }

            let isHover = false;
            if(hoverDim && node[hoverDim]){
                if(node[hoverDim] == hoverVal){
                    isHover = true;
                    opacity = 1;
                }else if(selected){
                    opacity = 0.5;
                }
            }

            let r = node['region'].toLowerCase();

            result.push(extend({
                uid: this.uid + '.' + c.id,
                properties: {
                    data: { 
                        id: c.id,
                        selected: selected,
                        data: data,
                        isHover: isHover,
                        opacity: opacity,
                        type: this.data.type,
                        color: selected? this.data.colors.highlight: this.data.colors.normal
                    }
                },
                private: {
                    path: c.path
                }
            }, Country));    

        }

        let globalBounds = null;
        if(highlight){
            globalBounds = geo.getBounds(highlight);
        }else{
            globalBounds = geo.getBounds(selection);
        }

        this.zoomTo(globalBounds);

        return result;

    }


} 


let Blueprint = {
    type: Controller,
    models: {
        'geo': null
    },
    listeners: [
        (ctrl) => ( ctrl.addListener(ctrl.models['geo']) ),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], ['map.itemHover', 'map.countryHighlight']) ),
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.userZoom], ['map.zoomScale', 'map.zoomPan']) )
    ],
    properties: {
        attributes:{
            'class': 'countries'
        },
        data: {
            selected: [],
            highlight: false,
            width: 500,
            height: 'auto',
            autoHeight: true,
            maxHeight: 800,
            maxScale: 1000,
            title: false,
            colors: {
                normal: [180,180,180],
                highlight: [255, 0, 0]
            }
        }
    },
    children: [
       (ctrl) => ( ctrl.getChildren() )
    ],
    events: {
        
    }
}


export default Blueprint;

